import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';
import { accountApi } from '../../services/accountApi';
import { ResetPasswordRequest } from '../../dtos/Accounts/index';

export function useResetPassword() {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (request: ResetPasswordRequest) => accountApi.resetPassword(request),
    onSuccess: (response) => {
      if (response.isSuccess) {
        toast.success('Parola a fost resetată cu succes. Vă puteți conecta acum.');
        navigate('/login');
      } else {
        toast.error(`Eroare: ${response.errorMessage || 'Nu s-a putut reseta parola'}`);
      }
    },
    onError: (error: Error) => {
      toast.error(`Eroare: ${error.message || 'Nu s-a putut reseta parola'}`);
    },
  });
}
